import $ from 'jquery';
import MQ from './mediaqueries';

/**
 * EqualHeight module.
 *
 * This will set all [data-equal-height] elements to the same height.
 */
class EqualHeight {

	constructor(el, options) {
		this.el = el;
		this.maxheight = 0;
		this.heightFixClass = 'height-fix';
		this.breakpointArray = ['', 'tiny-up', 'small-up'];
		this.currentBreakpoint = MQ.currentBreakpoint;
		this.init();
	}

	/**
	 * Initialization of the module
	 */
	init() {
		
		this._resizeListener();
		this._setEqualHeight();
	}

	/**
	 * 
	 */
	_resizeListener() {
		['resize', 'orientationchange', 'load'].forEach((e) => {

			window.addEventListener(e, () => {
				this._resetElements();
				this.currentBreakpoint = MQ.currentBreakpoint;
				this._setEqualHeight();
			});
		});
	}

	_resetElements() {
		this.el.querySelectorAll('[data-equal-height]').forEach((el) => {
			el.style.height = null;
			$(el).removeClass(this.heightFixClass);
		});
	}

	/**
	 * The actual function to set the equal height properties
	 */
	_setEqualHeight() {
		if ($.inArray(this.currentBreakpoint, this.breakpointArray) === -1) {
			this.el.querySelectorAll('[data-equal-height]').forEach((el) => {
				this.maxheight = this.maxheight > el.clientHeight ? this.maxheight : el.clientHeight;
			});

			this.el.querySelectorAll('[data-equal-height]').forEach((el) => {
				if (el.clientHeight < this.maxheight) {
					var $el = $(el),
						paddingOffset = parseInt($el.css('padding-top')) + parseInt($el.css('padding-bottom'));

					el.style.height = (this.maxheight - paddingOffset) + "px";


					$el.addClass(this.heightFixClass);
				}
			});
		}
	}
}

export { EqualHeight as EqualHeight };
